import { cn } from '~/styles/extended-theme';

interface FeatureCardProps {
  title: string;
  icon: React.ReactNode;
  description: string;
  imageSrc: string;
  imageAlt: string;
  variant: 'athlete' | 'gym-owner';
}

export function FeatureCard({
  title,
  icon,
  description,
  imageSrc,
  imageAlt,
  variant,
}: FeatureCardProps) {
  const isAthleteVariant = variant === 'athlete';
  const textColorClass = isAthleteVariant ? 'text-white' : 'text-gray-900';
  const imageHeight = isAthleteVariant
    ? 'h-[250px] tablet:h-[210px] desktop:h-[285px]'
    : 'h-[203px] tablet:h-[158px] desktop:h-[224px]';
  const imageMargin = isAthleteVariant ? 'mt-[-20px] desktop:mt-0' : '';

  const content = (
    <div className={cn('flex w-full flex-col gap-4', 'tablet:w-[282px]', 'desktop:w-[399px]')}>
      <p className={`text-h4 ${textColorClass}`}>{title}</p>
      {icon}
      <p className={`text-body1 ${textColorClass}`}>{description}</p>
    </div>
  );

  const image = (
    <img
      src={imageSrc}
      alt={imageAlt}
      className={`${imageMargin} ${imageHeight} w-full tablet:w-[280px] desktop:w-[399px]`}
    />
  );

  return (
    <div className="flex flex-col gap-4 tablet:flex-row tablet:gap-8 desktop:items-center desktop:gap-9">
      {/* Always show image first in mobile, maintain original order in tablet/desktop */}
      <div className={cn('tablet:order-none', !isAthleteVariant && 'tablet:order-last')}>
        {image}
      </div>
      <div className={cn('tablet:order-none', isAthleteVariant && 'tablet:order-last')}>
        {content}
      </div>
    </div>
  );
}
